import EditOrderPage from '../../../components/pages/mypages/wish_lists/EditOrderPage.vue'

export default {
  components: { EditOrderPage }
}
